<template>
    <div class="exchange-main">
        <div class="drawer-box">
            <div class="img_close-box"><img @click="closeButton" src="@/assets/icon／close (1).png" class="img_close"></div>
            <div class="title" v-show="pageNul == 0 ? true : false">Redeem points</div>
            <div class="title" v-show="pageNul == 1 ? true : false">Please enter your email to accept the redemption code</div>
            <div class="input_title" v-show="pageNul == 0 ? true : false">Redemption code</div>
            <div class="input_title" v-show="pageNul == 1 ? true : false">Email</div>
            <input type="text" class="input_style" :spellcheck="false" v-model="inputModel"
                :placeholder="inputPlaceholder">
            <div :class="{'submit_button':true,'no_button':inputModel == ''?true:false}" @click="submitButton">
                {{pageNul == 0?'exchange':'Next step'}}
            </div>
            <div class="toEmail_box" v-show="pageNul == 0 ? true : false">
                <div :class="{'toEmail':true,'toMouseoverStyle':isMouseover == true?true:false}" @mouseover="toEmailMouseover" @mouseout="toEmailMouseout" @click="toEmailButton">No redemption code, click to purchase</div>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
import {toRedeemPoints} from '@/api/modules/model'
import useGloubStore from '@/store'
import { ElMessage } from 'element-plus'
import router from '@/router';

export default {
    name: 'ExchangeDrawer',
    props:{
        offExchange:{
            type:Function
        }
    },
    setup(props) {
        const gloubStore = useGloubStore()
        const {offExchange} = props
        const state = reactive({
            pageNul: 0,// 0 表示兑换页面，1 ：邮箱页面
            inputModel: '',// 输入框
            inputPlaceholder: 'Please enter the redemption code',
            isMouseover:false,// 鼠标划入
        })
        // 鼠标划入
        function toEmailMouseover(){
            state.isMouseover = true
        }
        function toEmailMouseout(){
            state.isMouseover = false
        }
        function toEmailButton(){
            router.push('/puchaseCredits')
            // state.pageNul = 1
            // state.inputModel = ''
            // state.inputPlaceholder = 'Please enter your email address'
        }
        function submitButton(){
            if(state.pageNul == 0 && state.inputModel != ''){ // 兑换页面
                toRedeemPointsFun() // 兑换接口
            }else if(state.pageNul == 1 && state.inputModel != ''){ // 邮箱页面

            }
        }
        // 兑换码兑换积分
        async function toRedeemPointsFun(){
            let res = await toRedeemPoints(state.inputModel)
            if(res.code == 200){
                gloubStore.point = res.data.point
                ElMessage.success("Reset successfully")
                closeButton()
            }else{
                ElMessage.error(res.msg)
            }
        }
        function closeButton(){
            offExchange()
        }
        return {
            ...toRefs(state),
            toEmailButton,
            submitButton,
            closeButton,
            toEmailMouseover,
            toEmailMouseout
        }
    }
}
</script>

<style lang="scss" scoped>
@font-face {
    font-family: BoldFonts;
    src: url('@/fonts/PingFang-SC-Bold.ttf');
}

@font-face {
    font-family: RegularFonts;
    src: url('@/fonts/PingFang-SC-Regular.ttf');
}

.exchange-main {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba($color: #000000, $alpha: 0.8);
    z-index: 35;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;

    .drawer-box {
        width: 5.06rem;
        height: 4.20rem;
        background: #FFFFFF;
        box-shadow: 0rem 0.1rem 0.4rem -0.04rem rgba(0, 0, 0, 0.02);
        border-radius: 0.2rem;
        padding: 0.28rem;
        box-sizing: border-box;

        .img_close-box {
            width: 100%;
            display: flex;
            justify-content: right;

            .img_close {
                width: 0.3rem;
                height: 0.3rem;
                display: block;
                cursor: pointer;
            }
        }

        .title {
            font-family: BoldFonts;
            font-weight: bold;
            font-size: 0.24rem;
            color: #536376;
            margin-top: 0.14rem;
            cursor: default;
        }

        .input_title {
            font-family: BoldFonts;
            font-weight: normal;
            font-size: 0.12rem;
            color: #536376;
            margin-top: 0.4rem;
            cursor: default;
        }

        .input_style {
            width: 100%;
            height: 0.56rem;
            background: #FFFFFF;
            border-radius: 0.6rem;
            outline-style: none;
            font-size: 0.16rem;
            font-weight: 400;
            color: #AEB2BC;
            padding: 0.1rem;
            display: block;
            box-sizing: border-box;
            border: none;
            border: #eceef3 solid 0.01rem;
            margin-top: 0.08rem;
        }

        .input_style::placeholder {
            color: #AEB2BC;
        }

        .submit_button {
            width: 100%;
            height: 0.56rem;
            background: #4B48FF;
            border-radius: 0.6rem;
            font-family: RegularFonts;
            font-weight: 400;
            font-size: 0.16rem;
            color: #FFFFFF;
            line-height: 0.56rem;
            text-align: center;
            margin-top: 0.78rem;
            cursor: pointer;
        }

        .no_button {
            background: rgba(75, 72, 255, 0.5) !important;
        }

        .toEmail_box {
            width: 100%;
            display: flex;
            justify-content: center;
            .toEmail {
                width: 2.8rem;
                font-family: RegularFonts;
                font-weight: 400;
                font-size: 0.14rem;
                color: #4B48FF;
                margin-top: 0.08rem;
                cursor: pointer;
            }
            .toMouseoverStyle{
                text-decoration:underline;
            }
        }
    }
}
</style>